export const dataTest = (name: string) => {
  const route = useRoute()
  return `${route.name as string}_${name}`
}
